export const LEAVE_CATEGORY = 'leaveCategory@allcategory';

export default {
    [LEAVE_CATEGORY]: {
        url: 'leave-category/get/all',
    }
};
